import React from "react";

export default function AccountingComponent() {
  return <div>ยังไม่เปิดใช้</div>;
}
